import { Immutable } from "immer";
import React from "react";

import { usePageURL } from "../../utils/urls";
import { ServiceFooter } from "../ServiceFooter";

type IProps = Immutable<{
    snippets: string;
    interval: number | null;
    loops: number | null;
}>;

export const ServiceFooterIsland = (
    props: IProps,
): React.JSX.Element | null => {
    const contactLink = usePageURL("contact_link");
    const home = usePageURL("home");
    const chatOfflineLink = contactLink || home;

    const snippetsJson = props.snippets;
    if (!snippetsJson) {
        return null;
    }

    const parsedData = (() => {
        try {
            return JSON.parse(snippetsJson) as {
                snippets: Parameters<typeof ServiceFooter>[0]["snippets"];
            };
        } catch {
            return null;
        }
    })();
    if (!parsedData) {
        return null;
    }

    return (
        <ServiceFooter
            snippets={parsedData.snippets}
            interval={props.interval}
            loops={props.loops}
            chatOfflineLink={chatOfflineLink}
        />
    );
};
